import { render, staticRenderFns } from "./ksSearch.vue?vue&type=template&id=3be8b9c4&scoped=true"
import script from "./ksSearch.vue?vue&type=script&lang=js"
export * from "./ksSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be8b9c4",
  null
  
)

export default component.exports